import { mapActions, mapGetters, mapMutations } from 'vuex'
import SeoForm from '@/components/seo-form/index.vue'

export default {
  name: 'setting-course-categories-seo',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      currentItem: 'settingCourseCategories/currentItem',
      seo: 'settingCourseCategories/seo',
      seoLoading: 'settingCourseCategories/seoLoading',
      updateSeoLoading: 'settingCourseCategories/updateSeoLoading',
      basicLocales: 'setting/basicLocales'
    })
  },
  components: {
    SeoForm
  },
  created () {
    if (!this.seo) {
      this.fetchData({
        id: this.currentItem.id
      })
    }

	this.$on('event-save', () =>{
	  this.$refs['seoForm'].$emit('event-submit');
	});
  },
  methods: {
    ...mapActions({
      fetchData: 'settingCourseCategories/GET_SEO',
      update: 'settingCourseCategories/UPDATE_SEO'
    }),
    ...mapMutations({
      setSeo: 'settingCourseCategories/SET_SEO'
    }),
    submit (formData) {
      formData.category_id = this.currentItem.id

      this.update(formData).then(() => {
        this.$toasted.success(this.$t('success_updated'));
      })
    }
  },
  destroyed () {
    this.setSeo(null)
  }
}
